// extracted by mini-css-extract-plugin
export var completionBody = "_ld-2";
export var completionCard = "_ld-0";
export var completionFooter = "_ld-3";
export var completionTitle = "_ld-1";